// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1VBLq","requiredAsterisk":"Info_requiredAsterisk__4cRg2"};